import { ref } from 'vue';

// Separar os estados do ícone flutuante e dos botões
const floatingIconActive = ref(false);
const buttonActiveId = ref(null);

export function useWhatsAppFormManager() {
  const openForm = (formId) => {
    if (formId === 'icon') {
      // Ícone flutuante
      floatingIconActive.value = true;
    } else {
      // Botões
      buttonActiveId.value = formId;
    }
  };

  const closeForm = () => {
    floatingIconActive.value = false;
    buttonActiveId.value = null;
  };

  const isFormActive = (formId) => {
    if (formId === 'icon') {
      return floatingIconActive.value;
    } else {
      return buttonActiveId.value === formId;
    }
  };

  return {
    openForm,
    closeForm,
    isFormActive,
  };
}